import { Grid } from '@mantine/core';
import { PageTitle } from 'components/PageTitle';
import { i18nKeys, useTranslation } from 'locales';
import { BankAccountsCard } from 'modules/Settings/Company/BankAccounts/BankAccountsCard';
import { CompanyProfileCard } from 'modules/Settings/Company/CompanyProfileCard';
import { CurrencyCard } from 'modules/Settings/Company/Currency/CurrencyCard';
import { PaymentMethodCard } from 'modules/Settings/Company/Payment/PaymentMethodCard';
import { ApiCard } from 'modules/Settings/Company/PublicApi/ApiCard';

export const CompanySettings = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle>{t(i18nKeys.SETTINGS.COMPANY.PROFILE)}</PageTitle>
      <Grid mb="xl" pb="xl" align="stretch">
        <Grid.Col span={12}>
          <CompanyProfileCard />
        </Grid.Col>
        <Grid.Col span={6}>
          <CurrencyCard />
        </Grid.Col>
        <Grid.Col span={6}>
          <BankAccountsCard />
        </Grid.Col>
        <Grid.Col span={6}>
          <ApiCard />
        </Grid.Col>
        <Grid.Col span={6}>
          <PaymentMethodCard />
        </Grid.Col>
      </Grid>
    </>
  );
};
